//Reset data
export const RESET = "CHAT_UPDATE_RESET"

export const SET_IS_UPDATED = "CHAT_UPDATE_SET_IS_CREATE"
export const SET_NOT_UPDATED = "CHAT_UPDATE_SET_NOT_CREATE"
//Loading
export const SET_TOGGLE_LOADING = "CHAT_UPDATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "CHAT_UPDATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "CHAT_UPDATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "CHAT_UPDATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "CHAT_UPDATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "CHAT_UPDATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "CHAT_UPDATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "CHAT_UPDATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "CHAT_UPDATE_SET_HIDE_MESSAGE"

//Data
export const SET_UPDATE = "CHAT_UPDATE_SET_UPDATE"
export const SET_CURRENT_ITEM = "CHAT_UPDATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "CHAT_UPDATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "CHAT_UPDATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "CHAT_UPDATE_SET_HIDE_MODAL"


export const SET_MODAL = "CHAT_UPDATE_SET_MODAL"
export const SET_MODAL_CONTENT = "CHAT_UPDATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "CHAT_UPDATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "CHAT_UPDATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "CHAT_UPDATE_SET_MODAL_TYPE"